<template>
    <nav class="mobile-tab-bar" aria-label="底部导航">
        <router-link
            to="/index"
            class="mobile-tab-bar__item"
            :class="{'mobile-tab-bar__item--active': questionActive}"
        >
            <svg class="mobile-tab-bar__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4.5 4.75h15a1.75 1.75 0 0 1 1.75 1.75v8.25a1.75 1.75 0 0 1-1.75 1.75H11l-4.75 3v-3H4.5a1.75 1.75 0 0 1-1.75-1.75V6.5A1.75 1.75 0 0 1 4.5 4.75Z" />
                <path d="M7.25 9h9.5M7.25 12.5h6.25" />
            </svg>
            <span>问答</span>
        </router-link>

        <router-link
            to="/product"
            class="mobile-tab-bar__item"
            :class="{'mobile-tab-bar__item--active': productActive}"
        >
            <svg class="mobile-tab-bar__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 7.25 12 3l8 4.25v9.5L12 21l-8-4.25v-9.5Z" />
                <path d="m4.4 7.45 7.6 4.1 7.6-4.1M12 11.55V21" />
            </svg>
            <span>产品</span>
        </router-link>

        <router-link
            to="/user/profile/setting"
            class="mobile-tab-bar__item"
            :class="{'mobile-tab-bar__item--active': userActive}"
        >
            <svg class="mobile-tab-bar__icon" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="8" r="3.25" />
                <path d="M5.25 19.25c.55-3.35 3.05-5.25 6.75-5.25s6.2 1.9 6.75 5.25" />
            </svg>
            <span>我的</span>
        </router-link>
    </nav>
</template>

<script>
export default {
    name: 'MobileTabBar',
    computed: {
        questionActive() {
            return !this.productActive && !this.userActive;
        },
        productActive() {
            return this.$route.path.startsWith('/product');
        },
        userActive() {
            return this.$route.path.startsWith('/user');
        },
    },
};
</script>

<style scoped lang="less">
.mobile-tab-bar {
    position: fixed;
    z-index: 1000;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    height: calc(56px + env(safe-area-inset-bottom));
    padding: 4px 0 env(safe-area-inset-bottom);
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.96);
    border-top: 1px solid #e8ebf0;
    box-shadow: 0 -4px 16px rgba(31, 45, 61, 0.04);
}

.mobile-tab-bar__item {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    color: #8a94a6;
    font-size: 11px;
    line-height: 1.2;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
}

.mobile-tab-bar__item:hover,
.mobile-tab-bar__item:focus {
    color: #8a94a6;
    text-decoration: none;
}

.mobile-tab-bar__item--active,
.mobile-tab-bar__item--active:hover,
.mobile-tab-bar__item--active:focus {
    color: #2478f2;
}

.mobile-tab-bar__icon {
    width: 23px;
    height: 23px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
</style>
